export default __webpack_public_path__ + "static/media/idCard.9d74d5b3.png";